import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import { Platform, FirebaseConfig } from '@pc/common';

@Injectable({
  providedIn: 'root'
})
export class FirebaseAnalyticsService {
  private isMobile = false;

  constructor() {
    this.isMobile = Capacitor.getPlatform() !== Platform.WEB;
  }

  public initFb(firebaseConfig: FirebaseConfig): void {
    if (!this.isMobile) {
      FirebaseAnalytics.initializeFirebase(firebaseConfig);
      FirebaseAnalytics.setCollectionEnabled({
        enabled: true
      });
    }
  }

  public logScreenView(screenName: string): void {
    if (this.isMobile) {
      FirebaseAnalytics.setScreenName({
        screenName: screenName.replace(/[\s/]+/g, '').toLowerCase(),
        nameOverride: screenName.replace(/[\s/]+/g, '').toLowerCase()
      });
    }
  }

  public logFireBaseEvent(eventName: string, eventProperties: object = {}): void {
    FirebaseAnalytics.logEvent({
      name: eventName.replace(/\s+/g, '_').toLowerCase(),
      params: eventProperties
    });
  }

  public setUserProperty(agentNumber: string): void {
    FirebaseAnalytics.setUserProperty({
      name: 'agent_number',
      value: agentNumber
    });
  }
}
